import { ValidationConsole } from './src/ValidationConsole.js';

window.customElements.define('validation-console', ValidationConsole);
